export default __webpack_public_path__ + "static/media/bg-cod-1.5e4b588f.png";